const email_pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const string_pattern = /^[a-z]+$/i;
const number_pattern = /^-?\d+$/;
const urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})(:[0-9]{1,5})?(\/[^\s]*)?$/i;
const successFormMessage = document.querySelector('.contactus-form-success__message');

const validateInput = (input, pattern, errMsg) => {
  pattern.test(input.value.trim()) ? Remove_Element(input) : Create_Element(input, errMsg);
};

const errorFieldWrapper = document.querySelector('.error-message').parentElement.getAttribute('class');

document.getElementById('reasonCallBack').addEventListener('keyup', function () {
  const errorElem = document.querySelector('#reasonCallBackError');
  this.value ? errorElem.classList.add('hidden') : errorElem.classList.remove('hidden');
  errorElem.classList.toggle('error-message', !this.value);
});

const titleInput = document.getElementById('title');
titleInput?.addEventListener('change', function () {
  const errorElem = document.querySelector('#titleError');
  this.value ? errorElem.classList.add('hidden') : errorElem.classList.remove('hidden');
  this.value ? titleInput.style.borderColor = '#f3f3f3' : titleInput.style.borderColor = '#de281d';
  errorElem.classList.toggle('error-message', !this.value);
});

const callBackTimeInput = document.getElementById('bestTimeToCall');
callBackTimeInput?.addEventListener('change', function () {
  const errorElem = document.querySelector('#best_timeErr');
  this.value ? errorElem.classList.add('hidden') : errorElem.classList.remove('hidden');
  this.value ? callBackTimeInput.style.borderColor = '#f3f3f3' : callBackTimeInput.style.borderColor = '#de281d';
  errorElem.classList.toggle('error-message', !this.value);
});

const handleInputKeyUp = function () {
  const { type, id, value } = this;
  if (type === "email") {
    validateInput(this, email_pattern, value.trim() === '' ? 'Indtast venligst din e-mailadresse' : 'Ugyldig e-mailadresse');
  } else if (type === "text" && (id === "firstName" || id === "lastName" || id == 'RegisterForm-followers' || id == 'RegisterForm-link')) {
    validateInput(this, string_pattern, value.trim() === '' ? `Inserisca il suo ${id === 'firstName' ? 'Nome.' : ' Cognome.'}` : 'Specialtegn og tal er ikke tilladt.');
    if (id == 'RegisterForm-link') {
      validateInput(this, urlRegex, value.trim() === '' ? 'Indtast venligst Antal følgere.' : 'Invalid Profile link');
    }
  } else if (type === "tel") {
    validateInput(this, number_pattern, value.trim() === '' ? `Inserisci il tuo numero di ${id === 'ContactForm-phone' ? 'telefono.' : 'Antal følgere'}.` : `${id === 'ContactForm-phone' ? 'Telefonnummer skal være et tal.' : 'Indtast venligst Antal følgere.'}`);
  }
};

document.querySelectorAll('#contact-form-popup input').forEach(input => input.addEventListener('keyup', handleInputKeyUp));

const Create_Element = (ele, errMsg) => {
  const errorElem = ele.closest(`.${errorFieldWrapper}`).querySelector('.error-message');
  if (errorElem) errorElem.remove();
  const newErrorElem = document.createElement("p");
  newErrorElem.classList.add("error-message");
  newErrorElem.textContent = errMsg;
  ele.closest(`.${errorFieldWrapper}`).appendChild(newErrorElem);
  ele.style.borderColor = '#de281d';
};

const Remove_Element = (ele) => {
  const errorElem = ele.closest(`.${errorFieldWrapper}`).querySelector('.error-message');
  if (errorElem) errorElem.remove();
  ele.style.borderColor = '#f3f3f3';
};

document.querySelector('.contactUs-btn').addEventListener('click', function (evt) {
  evt.preventDefault();

  let isValid = true
  let errorMsg = document.querySelectorAll('#contact-form-popup .error-message');
  const textarea = document.querySelector('#contact-form-popup textarea');

  errorMsg.forEach((item, index) => {
    const field = item.closest('.field');
    const input = field.querySelector('input') || field.querySelector('select') || field.querySelector('textarea')
    item.classList.remove('hidden');
    if (input) {
      input.style.borderColor = '#de281d';
    }
  })

  // validate recaptch
  // const recaptchaErrorDiv = document.querySelector(".captcha-alert");
  // if (isValid) {
  //     let recaptchaResponse = grecaptcha.getResponse();
  //     if (!recaptchaResponse) {
  //       recaptchaErrorDiv.classList.remove("hidden");
  //       isValid = false;
  //     } else {
  //       recaptchaErrorDiv.classList.add("hidden");
  //     }
  //   }

  if (errorMsg.length == 0 && isValid) {
    successFormMessage?.classList.remove('hidden');
    sessionStorage.setItem('contactUs', "contactUs");
    setTimeout(() => {
      this.closest('form').submit();
    }, 1000);
  }
})

let isRecaptchaOpen = false;
document.addEventListener("click", function (event) {
  const recaptchaPopup = document.querySelector(".g-recaptcha");
  const recaptchaIframe = document.querySelector(
    ".g-recaptcha-bubble-arrow"
  )?.parentElement;
  const contactUsForm = document.querySelector("#contact-form-popup .popup-body");

  if (recaptchaIframe && recaptchaIframe.style.visibility !== "hidden") {
    isRecaptchaOpen = true;
  } else {
    isRecaptchaOpen = false;
  }

  if (
    isRecaptchaOpen &&
    recaptchaPopup &&
    !recaptchaPopup.contains(event.target) &&
    !contactUsForm.contains(event.target)
  ) {
    if (typeof grecaptcha !== "undefined") {
      grecaptcha.reset();
      isRecaptchaOpen = false;
    }
  }
});

const togglePopup = (action) => {
  document.querySelector(".popup-contact-fixed").classList[action]("hidden");
  document.body.classList.toggle('custom-overflow-hidden1');
};

document.querySelector(".btn-contact-url").addEventListener("click", () => togglePopup("remove"));
document.querySelector(".popup-contact-fixed .popup-overlay").addEventListener("click", () => {
  togglePopup("add")
  clearFormErrors();
});
document.querySelector(".popup-contact-fixed .close").addEventListener("click", () => {
  togglePopup("add");
  clearFormErrors();
});

function clearFormErrors() {
  const errorMessages = document.querySelectorAll('.error-message');
  errorMessages?.forEach((each) => {
    const field = each.closest('.field');
    const input = field?.querySelector('input') || field?.querySelector('select') || field?.querySelector('textarea')
    each.classList.add('hidden')
    if (input) {
      input.style.borderColor = '#efefef';
    }
  });
}


const messageCloseButton = document.querySelector('.contactus-form-success__message .close__icon');
messageCloseButton?.addEventListener('click', () => {
  successFormMessage?.classList.add('hidden');
})